import { isDefaultIban } from './treasuryWarnings';

// An IBAN's format and checksum (Spanish and Andorran accounts)
export const validateIban = (iban) => {
    if (!iban) return { valid: false, error: 'L\'IBAN és obligatori' };
    
    // Remove spaces and dashes, convert to uppercase
    const cleanIban = iban.replace(/[\s-]/g, '').toUpperCase();
    
    // Skip validation for default placeholder patterns
    if (isDefaultIban(iban)) {
        return { valid: false, error: 'L\'IBAN no pot ser un valor per defecte' };
    }
    
    // Check length (Spanish and Andorran IBANs are 24 characters)
    if (cleanIban.length !== 24) {
        return { valid: false, error: `L'IBAN ha de tenir 24 caràcters (actual: ${cleanIban.length})` };
    }
    
    // Check country code (ES for Spain, AD for Andorra)
    if (!cleanIban.startsWith('ES') && !cleanIban.startsWith('AD')) {
        return { valid: false, error: 'L\'IBAN ha de començar amb ES o AD' };
    }
    
    // Check that all characters after country code are digits
    if (!/^(ES|AD)\d{22}$/.test(cleanIban)) {
        return { valid: false, error: 'L\'IBAN ha de contenir només dígits després del codi de país' };
    }
    
    // Validate IBAN checksum (mod 97)
    // Move first 4 chars to end and convert letters to numbers (A=10, B=11, etc.)
    const rearranged = cleanIban.slice(4) + cleanIban.slice(0, 4);
    const numericString = rearranged.replace(/[A-Z]/g, char => (char.charCodeAt(0) - 55).toString());
    
    // Calculate mod 97 in chunks (number is too large for regular JS numbers)
    let remainder = 0;
    for (let i = 0; i < numericString.length; i++) {
        remainder = (remainder * 10 + parseInt(numericString[i], 10)) % 97;
    }
    
    if (remainder !== 1) {
        return { valid: false, error: 'L\'IBAN no és vàlid (dígits de control incorrectes)' };
    }
    
    return { valid: true, error: null };
};
